import PropTypes from 'prop-types';
import React from 'react';
import {Link} from 'react-router-dom';
import {includes} from 'lodash';
import {getMedia, watchMedia} from 'shared/mq';
import {EARNING_STATUSES, pluralize} from 'shared/utils';
import Icon from 'shared/components/icon';
import EarningText from 'shared/college-earnings/components/earning-text';
import NotEarningText, {
  NOT_EARNING_STATUS_COMPONENTS,
} from 'shared/college-earnings/components/not-earning-text';
import {shortCollegeName} from 'shared/college-earnings/utils';

class Earning extends React.Component {
  static propTypes = {
    earnings: PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      amount: PropTypes.number,
      nickname: PropTypes.string,
      divisor: PropTypes.number.isRequired,
      earningRelationship: PropTypes.shape({
        statusType: PropTypes.string.isRequired,
      }).isRequired,
      creditsRequired: PropTypes.number,
      maxEarnings: PropTypes.number,
      useApplyByTerminology: PropTypes.bool,
    }).isRequired,
    previousEarnings: PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
      earningRelationship: PropTypes.shape({
        statusType: PropTypes.string.isRequired,
      }).isRequired,
      creditsRequired: PropTypes.number,
    }),
    animating: PropTypes.bool,
    showNewEarnings: PropTypes.bool,
  };

  state = {
    active: false,
  };

  UNSAFE_componentWillMount() {
    this.mq = watchMedia(() => {
      this.forceUpdate();
    });
  }

  componentWillUnmount() {
    this.mq.remove();
  }

  getClassName = (difference) => {
    const {animating, showNewEarnings} = this.props;

    let className = 'college-earnings-earning';

    if (this.state.active) {
      className += ' active';
    }
    if (animating && showNewEarnings && difference !== 0) {
      if (difference > 0) {
        className += ' increased';
      } else {
        className += ' decreased';
      }
    }

    return className;
  };

  setActiveClass =
    (activeSetting, mediaQuery = true) =>
    () => {
      mediaQuery && this.setState({active: activeSetting});
    };

  render() {
    const mq = getMedia();

    const {
      earnings: {
        slug,
        amount,
        divisor,
        name,
        nickname,
        earningRelationship,
        earningRelationship: {statusType},
        creditsRequired,
        maxEarnings,
        useApplyByTerminology,
      },
      previousEarnings,
      showNewEarnings,
      animating,
    } = this.props;

    const prevEarning = previousEarnings ? previousEarnings.amount : 0;
    const difference = (amount || 0) - prevEarning;

    const maxStudentEarningsReached = !!maxEarnings && amount >= maxEarnings;

    return (
      <div className="earning-and-menu-container transfer">
        <Link
          className={this.getClassName(difference)}
          onMouseDown={this.setActiveClass(true)}
          onMouseOver={this.setActiveClass(true, mq.MD_AND_UP)}
          onFocus={this.setActiveClass(true, mq.MD_AND_UP)}
          title={this.props.earnings.name}
          onMouseOut={this.setActiveClass(false)}
          onBlur={this.setActiveClass(false)}
          to={`/edu/${slug}`}
        >
          <div className="college-earnings-earning-container">
            <div className="prefix-flex prefix-align-items">
              <img
                className="college-earnings-earning-image"
                alt={`${this.props.earnings.name} logo`}
                src={`//colleges-static.raise.me/${slug}/logo-120x120.png`}
              />
              <div className="prefix-flex-grow-1 college-earnings-earning-name">
                {shortCollegeName(name, nickname, includes(EARNING_STATUSES, statusType))}
              </div>
              <EarningText
                status={statusType}
                earnings={amount}
                earningsDivisor={divisor}
                difference={difference}
                previousEarnings={prevEarning}
                animated={animating}
                showNewEarnings={showNewEarnings}
                maxStudentEarningsReached={maxStudentEarningsReached}
              />
            </div>
            {statusType === 'scholarships_not_yet_available' || !creditsRequired ? null : (
              <CreditHoursText creditHours={creditsRequired} />
            )}
            {!!NOT_EARNING_STATUS_COMPONENTS[statusType] && (
              <hr className="college-earnings-status-divider" />
            )}
            <NotEarningText
              relationship={earningRelationship}
              useApplyByTerminology={useApplyByTerminology}
            />
          </div>
        </Link>
      </div>
    );
  }
}

const CreditHoursText = ({creditHours}) => (
  <div className="college-earnings-credit-hours-text">
    <Icon iconType="clock-o" />
    <span className="college-earnings-credit-hours-text-credits">
      {creditHours} more {pluralize(creditHours, 'credit hour')} needed to receive your earnings
    </span>
  </div>
);

CreditHoursText.propTypes = {
  creditHours: PropTypes.number.isRequired,
};

export default Earning;
